module.exports = __webpack_public_path__ + "assets/images/project/people/mansenior.svg?v=4816fb3e";